import Loadable from "react-loadable";

export const ManagePostsGrid = Loadable({
  loader: () => import("../../../../modules/manage-posts").then((module) => module.ManagePostsGrid) as Promise<any>,
  loading: () => null,
});
